import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AiOutlineWarning } from "react-icons/ai";

import ConfirmationModal from "../../../Dialogs/ConfirmationModal";
import { Color } from "../../../Form/Button";
import useStyles from "./styles";

export interface BookingConfirmationModalHandles {
  open: (status: string) => void;
  close: () => void;
}
interface BookingConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: () => void;
  loadingAction?: boolean;
}

const BookingConfirmationModal: ForwardRefRenderFunction<
  BookingConfirmationModalHandles,
  BookingConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const [status, setStatus] = useState<string>("");
  const { closeModal, loadingAction, onSubmit } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const open = useCallback((status: string) => {
    setOpenModal(true);
    setStatus(status);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
    setStatus("");
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return (
    <ConfirmationModal
      width="520px !important"
      open={openModal}
      closeModal={() => {
        if (closeModal) closeModal();
        close();
      }}
      type="warning"
      title={`${translate("changeStatusTo")} "${status}"`}
      leftIconTitle={<AiOutlineWarning color="#F79009" size={20} />}
      loading={loadingAction}
      cancelDisabled={loadingAction}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.WARNING}
      textCancel={translate("noThanks")}
      textSubmit={translate("changeIt")}
      submit={() => onSubmit()}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.reviewModalContainer}>
          <div data-cy="confirmationModalWarningBody" className={classes.descriptionModalConfirm}>
            <span>
              {translate("areYouSureYouWantToChangeThisBookingStatusTo")}
              {` "${status}" ?`}
            </span>
            <span className="warning">
              {translate("weightAndCBMOfThisBookingMustBeConfirmedBeforeThisCanBeDone")}
            </span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(BookingConfirmationModal);
